import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "value", "children", "sx"];
import LoadingButton from '@mui/lab/LoadingButton';
export default function FormButton(props) {
    var onClick = props.onClick, value = props.value, children = props.children, sx = props.sx, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(LoadingButton, _extends({
        onClick: onClick,
        sx: sx
    }, others), children);
}
